import {SliderSlick} from './SliderSlick';
export default SliderSlick;
